(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/betslip/amount-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/betslip/amount-picker.js');
"use strict";


const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const ReactIcon = svs.ui.ReactIcon;
const gameTypes = svs.racing.common.constants.gameTypes;
const {
  useState
} = React;
const {
  Input
} = svs.ui.form;
const AmountPicker = _ref => {
  let {
    amounts,
    setSelectedAmount,
    selectedAmount,
    isFreeAmountAvailable,
    gameType,
    amountDisabled = [false, false, false],
    maxStake,
    minInputRowPrice
  } = _ref;
  const isHighFive = gameType === gameTypes.TOPP5;
  const [focusInput, setFocusInput] = useState(false);
  let headerText = 'Radinsats';
  headerText = gameType === gameTypes.VINNARE || gameType === gameTypes.PLATS ? 'Insats per häst' : headerText;
  const handleHelpButtonClick = e => {
    if (svs.racing_game.data.racingconfig.helpTexts.row_price) {
      const _dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: e.currentTarget,
        zIndex: 1100,
        title: svs.racing_game.data.racingconfig.helpTexts.row_price.title,
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: svs.racing_game.data.racingconfig.helpTexts.row_price.body
        }]
      });
      svs.components.dialog.api.add(_dialog);
    }
  };
  const handleChangePrice = (event, setSelectedAmount) => {
    setFocusInput(false);

    const value = event.target.value.replace(/[^0-9]/g, '');
    const numberValue = parseInt(value, 10);

    const validatedValue = numberValue > maxStake ? maxStake : numberValue;
    setSelectedAmount(validatedValue ? validatedValue : 0);
  };
  return React.createElement("div", {
    className: "betslip-amount-picker"
  }, React.createElement("div", {
    className: "picker-header"
  }, headerText, isHighFive && React.createElement("button", {
    className: "align-bottom icon-button padding-xs-h",
    onClick: e => handleHelpButtonClick(e),
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "fc-sport",
    icon: "help",
    size: "300"
  }))), React.createElement("div", {
    className: "amount-picker form-toggle-racing"
  }, React.createElement(RadioGroup, {
    id: "betslip-amount-picker",
    multipleLines: false,
    size: "200",
    thin: true,
    transparent: false
  }, amounts.map((amount, index) => React.createElement(RadioButton, {
    branding: "racing",
    checked: amount === selectedAmount,
    disabled: amountDisabled[index],
    key: "betslip-amountpicker-value-".concat(amount),
    minWidth: "100px",
    name: "betslip-amountpicker-value--button",
    onChange: amount => setSelectedAmount(amount),
    value: amount
  }, amount, ' ', "kr")))), isFreeAmountAvailable && React.createElement("div", {
    className: "betslip-amount-input"
  }, React.createElement(Input, {
    autoComplete: "off",
    onBlur: () => setFocusInput(false),
    onChange: e => handleChangePrice(e, setSelectedAmount),
    onFocus: () => setFocusInput(true),
    placeholder: "Eget belopp, minst ".concat(minInputRowPrice, " kr"),
    suffix: "kr",
    type: "tel",
    value: focusInput ? '' : (selectedAmount || '').toString()
  })));
};
svs.racing_game.components.play.AmountPicker = AmountPicker;

 })(window);